import { ApiErrorDisplay } from '@/types/apiError';
import { Alert, AlertProps } from '@mui/material';
import { forwardRef } from 'react';

export const ApiErrorAlert = forwardRef<HTMLDivElement, { error?: ApiErrorDisplay } & Omit<AlertProps, 'severity'>>(
  ({ error, ...alertProperties }, reference) => {
    if (!error || !error?.message) {
      return;
    }

    return (
      <Alert severity='error' {...alertProperties} ref={reference}>
        {error.message}
        <br />
        {error.traceId && (
          <small>
            Error code: <code>{error.traceId}</code>
          </small>
        )}
      </Alert>
    );
  }
);

ApiErrorAlert.displayName = 'ApiErrorAlert';
